import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import { controlPropTypes } from "../formhelpers";

export default class Label extends React.Component {
    render() {
        const { descriptor, value } = this.props;
        const valueStr = ArmusScript["dateFormat(Date,String)"](value, descriptor.config.mask) || "";
        return (
            <ControlTemplate {...this.props} className="date-field" >
                <span>{valueStr}</span>
            </ControlTemplate>
        );
    }
}

Label.propTypes = controlPropTypes();



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/DateField/label.js